import { default as ReactSelect, components } from "react-select";
import ReactTooltip from "react-tooltip";

const CheckboxSelect = ({ options, onChange, value = [], maxSelection }) => {
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input type="checkbox" checked={props.isSelected} onChange={() => null} className={props?.selectProps?.value?.length < +maxSelection ? "form-check-input custom-checkbox-select" : props.isSelected ? "form-check-input custom-checkbox-select" : "form-check-input custom-checkbox-select custom-checkbox-unselect"} />{" "}
          <label className="checboxselectlabel" data-tip={props?.selectProps?.value?.length < +maxSelection ? "" : props.isSelected ? "" : "You can select maximum of 5 values."} data-for={"propslabel"}>
            {props.label}
          </label>
          {props?.selectProps?.value?.length < +maxSelection ? "" : props.isSelected ? "" : <ReactTooltip className="trademo-tooltip text-capitalize" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" multiline={true} id={"propslabel"} />}
        </components.Option>
      </div>
    );
  };
  const searchTypeCustomStyles = {
    control: (base, { isFocused }) => ({
      ...base,
      minHeight: 44,
      backgroundColor: isFocused ? "#fff" : "#f9fafb",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: 400,
      color: "#101828",
      border: isFocused ? "1px solid #6f08f1" : "1px solid #dddfe4",
      boxShadow: isFocused ? "0 0 0 2px #e4dbfa" : "none",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "14px",
      fontWeight: 400,
      padding: "4px",
    }),
    menuList: (baseStyles) => ({
      ...baseStyles,
      padding: "0px 0px 0px 12px",
    }),
    option: (baseStyles, state) => {
      return {
        ...baseStyles,
        backgroundColor: "transparent !important",
        color: value?.length < +maxSelection ? "black" : state.isSelected ? "black" : "#667085",
        "&:hover": {
          color: value?.length < +maxSelection ? "black" : state.isSelected ? "black" : "#667085",
          backgroundColor: "transparent !important",
        },
      };
    },
  };
  return (
    <div>
      <ReactSelect
        options={options}
        menuPosition="fixed"
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option,
        }}
        menuContainerStyle={{ zIndex: 999 }}
        isOptionDisabled={true}
        styles={searchTypeCustomStyles}
        onChange={(val) => onChange(val)}
        placeholder={"You can select multiple options"}
        allowSelectAll={true}
        value={value}
      />
    </div>
  );
};

export default CheckboxSelect;
